/*
 *  DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 *  THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 *  INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 *  HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 *  AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 *  THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 *  EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 *  Copyright (C) 2021 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 */

export const ASSETS_DATA_SET_TYPE = {
    SHALLOW: 'SHALLOW',
    SHALLOW_WITH_FAULT_COUNT: 'SHALLOW_WITH_FAULT_COUNT',
}